import { Check } from "lucide-react";
import { useIntl } from "react-intl";

import { Button, type ButtonElementProps } from "../../../../../atoms/button";

export function DataFormPreferencesSaveButton({
  children,
  iconLeft = { Icon: Check },
  ...props
}: ButtonElementProps) {
  const intl = useIntl();
  return (
    <Button {...props} iconLeft={iconLeft}>
      {children ??
        intl.formatMessage({
          id: "data-form-preferences.save",
          defaultMessage: "Uložit",
        })}
    </Button>
  );
}
